import { GetCurrentAssessmentResultsResult } from "../../../assessments";

export class GetAdminResultsResult extends GetCurrentAssessmentResultsResult {}